import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, onMounted, computed } from 'vue';
import { PropType } from 'vue'
import tools from '@/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
  label: {
    type: String,
    default: '图片上传'
  },
  name: {
    type: String,

  },
  folder: {
    type: String,
    default: 'temp'
  },
  count: {
    type: Number,
    default: 1
  },
  rules: Array,
  value: {
    type: Array,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props

const Options = ref({
  name: '上传文件'
})

onMounted(() => {

})





const beforeRead = (file: any, detail: any) => {
  // 此时可以自行将文件上传至服务器

  let fileName = ''


  if (file.name) {
    fileName = `${tools.data.objectid.generate()}.${file.name.substring(file.name.lastIndexOf('.') + 1)}`
  }

  tools.cloud.app.uploadFile({
    // 云存储的路径
    cloudPath: `${props.folder}/${fileName}`,
    // 需要上传的文件，File 类型
    filePath: file
  })
    .then((res: any) => {
      // 返回文件 ID

      const list = [...props.value]
      list.push({
        uid: res.fileID,
        name: props.name,
        status: 'done',
        response: `{'status':'success'}`,
        url: res.download_url,
        isImage: false
      })
      emit('update:value', list)

      // file.status = 'success';
      // file.message = '上传失败';

      return false

    });


};

const beforeDelete = (file: any) => {

  const index = props.value.findIndex((r: any) => r.uid === file.uid)
  if (index !== -1) {

    tools.cloud.app.deleteFile({
      fileList: [file.uid]
    })
      .then((res) => {
        props.value.splice(index, 1)
        return true
      });
  }

}



return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, { placeholder: __props.label }, {
      label: _withCtx(() => [
        _createElementVNode("view", {
          style: _normalizeStyle({ color: props.disabled ? '#c8c9cc' : '#646566' })
        }, _toDisplayString(__props.label), 5)
      ]),
      input: _withCtx(() => [
        _createVNode(_component_van_uploader, {
          disabled: props.disabled,
          accept: "*",
          modelValue: __props.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          "max-count": __props.count,
          "before-read": beforeRead,
          "before-delete": beforeDelete
        }, null, 8, ["disabled", "modelValue", "max-count"])
      ]),
      _: 1
    }, 8, ["placeholder"])
  ]))
}
}

})